import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { useMusicContext } from '../../contexts/MusicContext';
import { AUDIO_CONFIG } from '../../config/features';
import '../../styles/backgroundMusic.css';

const BackgroundMusic = () => {
  const { isMusicActive } = useMusicContext();
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(0);

  const tracks = AUDIO_CONFIG.tracks;

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * tracks.length);
    setCurrentTrack(randomIndex);
  }, [tracks.length]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = AUDIO_CONFIG.defaultVolume;
    }
  }, [currentTrack]);

  useEffect(() => {
    if (!isMusicActive && audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else if (isMusicActive && audioRef.current && isPlaying) {
      audioRef.current.play();
    }
  }, [isMusicActive, isPlaying]);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleAudioEnd = () => {
    const randomIndex = Math.floor(Math.random() * tracks.length);
    setCurrentTrack(randomIndex);
    if (audioRef.current) {
      setTimeout(() => {
        audioRef.current.play();
      }, AUDIO_CONFIG.trackSwitchDelay);
    }
  };

  if (!isMusicActive) {
    return null;
  }

  return (
    <div className={`bgmusic ${isPlaying ? 'is-playing' : ''}`} id="bgmusic">
      <div className="bgmusic__meta">
        <span className="status-text">
          {isPlaying ? 'Música activa' : 'Música pausada'}
        </span>
        <span className="track-text">{tracks[currentTrack].name}</span>
      </div>

      <button
        type="button"
        className="bgmusic__toggle"
        onClick={togglePlay}
        aria-pressed={isPlaying}
        aria-label={isPlaying ? 'Pausar música de fondo' : 'Reproducir música de fondo'}
      >
        <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
      </button>

      <audio
        ref={audioRef}
        id="bgaudio"
        src={`/music/${tracks[currentTrack].file}`}
        onEnded={handleAudioEnd}
        preload="metadata"
      />
    </div>
  );
};

export default BackgroundMusic;
